import { useEffect, useState } from 'react';
import { getToken } from 'firebase/messaging';
import { Box, IconButton, Tooltip } from '@mui/material';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import { onMessage } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { firebaseConfig, firebaseVapidToken } from '../../firebase.js';
import { registerDeviceForPushNotifications } from '../resources/chat/chatHttpClient.js';

// Handle initialization of browser push notifications, setup Firebase token and register with backend.
export const NotificationsSetup = () => {
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    initializeNotificationToken();
  }, []);

  const activatePushNotificationHandler = async () => {
    const messaging = getMessaging();
    onMessage(messaging, payload => {
      // FCM: Message received in foreground

      // Currently not performing any logic if app is in foreground. Websocket subscriber should handle this.
    });
  };

  const initializeNotificationToken = async () => {
    // FCM: Initializing...
    setError(null);
    try {
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);

      const firebaseDeviceToken = await getToken(messaging, {
        vapidKey: firebaseVapidToken,
      });

      if (firebaseDeviceToken) {
        // FCM: registered with token
        await registerDeviceForPushNotifications({ deviceToken: firebaseDeviceToken });
        activatePushNotificationHandler();
      } else {
        // FCM Error: No registration token available. Request permission to generate one.
        setError(new Error('No registration token available. Request permission to generate one.'));
      }
    } catch (error) {
      // FCM Error occurred
      setError(error instanceof Error ? error : new Error('Unknown error'));
    }
  };

  // User interaction to request notification permission (Safari requires this!)
  const requestNotificationPermission = async () => {
    // FCM: Requesting notification permissions...
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        // FCM: Notification permission granted.
        initializeNotificationToken();
      } else {
        // FCM: Unable to get permission to notify.
      }
    });
  };

  return (
    <>
      {error ? (
        // Show error message and button to request notification permissions
        <>
          <IconButton onClick={(e: any) => requestNotificationPermission()}>
            <Tooltip title="Push notifications not active. Click here to enable them now, or use your browser's settings to allow notifications for this site.">
              <NotificationAddIcon color="error" />
            </Tooltip>
          </IconButton>
          <Box className="ext-horizontal-separator" component="span" />
        </>
      ) : (
        <>
          {/* {!token && (
            // Loading state
            <Typography>...</Typography>
          )} */}
        </>
      )}
    </>
  );
};
